import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { TASK_CATEGORY_API } from "../apiRoutes";

interface UseGetTaskCategoriesByProjectProps {
  projectId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getTaskCategoriesByProject = async (projectId: string) => {
  return await axiosAuth.get(`${TASK_CATEGORY_API}/project/${projectId}`);
};

const useGetTaskCategoriesByProject = ({
  projectId,
  queryParams,
}: UseGetTaskCategoriesByProjectProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["tak-categories", projectId],
    queryFn: () => getTaskCategoriesByProject(projectId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetTaskCategoriesByProject;
